import { Component, OnInit } from '@angular/core';
import {
  ModalDismissReasons,
  NgbModal,
  NgbModalRef,
} from '@ng-bootstrap/ng-bootstrap';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { FilesByAppointmentIdResponseModel } from 'projects/Administration/src/app/business-entities/dwo-documents.model';
import { EditAppointmentService } from 'projects/Administration/src/app/business-services/edit-appointment.service';
import { FileSizePipe } from 'projects/Autofacets-Core/src/app/pipes/filesize/filesize';
import { DwoDocumentsBusinessService } from './../../../../../../../business-services/dwo-documents.service';
import { SecureStorage } from 'projects/Autofacets-Core/src/app/common-services/SecureStorage.service';
import { Features } from 'projects/Administration/src/app/business-entities/user-role-view-model';
import * as Enums from './../../../../../../../../../../Autofacets-Core/src/app/utils/enums';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Utility } from 'projects/Autofacets-Core/src/app/utils/utility';
import * as FileSaver from 'file-saver';
import * as JSZip from "jszip";

@Component({
  selector: 'app-dwo-documents',
  templateUrl: './dwo-documents.component.html',
  styleUrls: ['./dwo-documents.component.css'],
  providers: [FileSizePipe],
})
export class DwoDocumentsComponent implements OnInit {
  response: FilesByAppointmentIdResponseModel;
  closeResult: string;
  url: string;
  audio: string;
  dailymotionUrl: string;
  private modalRef: NgbModalRef;
  searchOpenClass = '';
  langCode: string;
  features: Features[] = [];
  isAllowMediaVisibility = false;
  mediaVisibilityEditable = false;
  appointmentGUID: any;
  userRole: number;
  AttatchmentTypeEnums = Enums.AttatchmentTypeEnums;
  activePanels: string[] = [];

  constructor(
    private readonly service: DwoDocumentsBusinessService,
    private readonly editAppointmentService: EditAppointmentService,
    private readonly modalService: NgbModal,
    private readonly spinner: NgxSpinnerService,
    private readonly cookieservice: CookieService,
    private readonly secureStorage: SecureStorage,
    private readonly userService: UserDataService,
    private readonly translate: TranslateService,
    private readonly toastr: ToastrService
  ) { }

  ngOnInit(): void {  
    //Check for historical WO tab -> If true then appointmentGuid will be of selected WO.
    if (
      this.editAppointmentService.isFromHistoricalWOTab ||
      this.editAppointmentService.isFromVehicleHistoricalTab
    ) {
      this.appointmentGUID = this.editAppointmentService.appointmentGuidOfSelectedWO;
    } else {
      this.appointmentGUID =
        this.editAppointmentService.appointmentDetails.appointmentGuid;
    }
    this.userRole = this.userService.currentUserValue.roleType;
    this.mediaVisibilityEditable = (this.userRole === Enums.UserRoles.SuperAdmin || this.userRole === Enums.UserRoles.ServiceAdvisor);
    this.getDocumentList(this.appointmentGUID);
    this.getFeatures();
  }

  getFeatures() {
    if (this.secureStorage.getKeyData('feature')) {
      this.features = this.secureStorage.getKeyData('feature');
      if (this.features && this.features.length > 0) {
        this.isAllowMediaVisibility = this.features.find(x => x.featureCode === Enums.FeatureCode.IsAllowMediaVisibility)?.isActive;
      }
    }
  }

  changeMediaVisibility(isShowToCustomer: boolean, file: any, files: any) {
    let dwoMediaVisibilityModel = {
      documentId: file.id,
      description: file.shortDescription,
      isShowToCustomer: isShowToCustomer,
      appointmentId: this.editAppointmentService.appointmentDetails.id
    }
    this.service.EditMediaVisibility(dwoMediaVisibilityModel).then((res) => {
      let mediaVisibilityMessage = this.translate.instant("lblChangedMediaVisibilitySuccessful");
      this.toastr.success(mediaVisibilityMessage);
    }).catch(err => {
      let errorMessage = this.translate.instant("lblErrorOccured");
      this.toastr.error(errorMessage);
      const docIndex = files.findIndex(x => x.id === file.Id);
      if (docIndex >= 0) {
        files[docIndex].isShowToCustomer = !isShowToCustomer;
      }
    });
  }

  async getDocumentList(id: string) {
    this.spinner.show();
    this.langCode = this.cookieservice.get('userSelectedLanguage');
    await this.service.getDwoDocumentList(id, this.langCode).then((res) => {
      this.response = res.responseObject;
      this.getActivePanelIds();
    });
    this.spinner.hide();
  }

  getActivePanelIds(){
    const newActivePanels: string[] = [];
    if(this.response != null){
      if (this.response.demandFiles?.length > 0) {
        newActivePanels.push('photo-video-tab');
      }
      if (this.response.checkListFiles?.length > 0) {
        newActivePanels.push('checklist-tab');
      }
      if (this.response.parkingLocationFiles?.length > 0) {
        newActivePanels.push('parking-tab');
      }
      if (this.response.customerUploadedFiles?.length > 0) {
        newActivePanels.push('other-tab');
      }
      if (this.response.additionalWorkFiles?.length > 0) {
        newActivePanels.push('additional-tab');
      }
      if (this.response.diagnoseCheckListFiles?.length > 0) {
        newActivePanels.push('diagnose-checklist-tab');
      }
      if (this.response.newWidgetFiles?.length > 0) {
        newActivePanels.push('new-widget-tab');
      }
    }
    this.activePanels = newActivePanels;
    return this.activePanels;
  }
  
  onPanelToggle(event: any){
    if (!this.activePanels.includes(event.panelId)) {
      this.activePanels.push(event.panelId);
    } else {
      this.activePanels = this.activePanels.filter(id => id !== event.panelId);
    }
  }

  open(content, path: string) {
    this.url = path;
    this.modalService
      .open(content, { ariaLabelledBy: 'modal-basic-title' })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        }
      );
  }


  public openVirtualTour(content, path: string) {
    this.dailymotionUrl = path;
    this.modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
    });
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  public openAudio(content, path: string) {
    this.audio = path;
    this.modalRef = this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
    });
    this.modalRef.result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  openDocuments(path: string) {
    this.url = path;
    if (this.url) {
      window.open(this.url, '_blank');
    }
  }

  async downloadFile(path: string) {
    this.spinner.show();
    await this.service.DownloadFile(path).then(
      (res: any) => {
        if (res && res.responseCode == 200) {
          const file = res.responseObject;
          const blob = Utility.base64toBlob(file.fileContents, file.contentType);
          FileSaver(blob, file.fileDownloadName);
        }
      }).finally(() => {
        this.spinner.hide();
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
  downloadAllDocument(documentList: any, folderName: any, event: any) {
    event.stopPropagation();
    let zipFiles = [];
    documentList.forEach(element => {
      zipFiles.push(element?.path);
    });
    let zipFileName = this.translate.instant(folderName);
    this.createZip(zipFiles, zipFileName)
  }

 async deleteSingleDocument(documentId: any, documentName:any, documentDemandid:any, deleteType: any = null){
    let appointmentId = this.editAppointmentService.appointmentDetails.id;
    let requestModel={
      documentId: documentId,
      documentName: documentName,
      documentDemandid: documentDemandid,
      appointmentId: appointmentId,
      type: deleteType
    }

    this.spinner.show(); 
    await this.service.deleteDocument(requestModel).then((res) => { 
      if (res) {
        let msg = this.translate.instant("lblDocumentDeletedSuccessfully");
        this.toastr.success(msg);
        this.getDocumentList(this.appointmentGUID);
      }
      else{
        let errMsg = this.translate.instant("lblDocumentNotDeleted");
        this.toastr.error(errMsg)
      } 
    }); 
    this.spinner.hide();
  }

  async createZip(files: any[], zipName: string) {
    this.spinner.show();
    const zip = new JSZip();
    const name = zipName + '.zip';
    // tslint:disable-next-line:prefer-for-of  
    for (let counter = 0; counter < files.length; counter++) {
      const element = files[counter];
      const fileData: any = await this.service.DownloadFile(element);
      const file = fileData.responseObject;
      const blob = Utility.base64toBlob(file.fileContents, file.contentType);
      zip.file(element.substring(element.lastIndexOf('/') + 1), blob);
    }
    zip.generateAsync({ type: 'blob' }).then((content) => {
      if (content) {
        FileSaver.saveAs(content, name);
      }
    });
    this.spinner.hide();
  }
}